<template>
  <div id="nav" style="z-index:99999;">
    <scrollactive
      class="navbar is-fixed"
      id="navbar"
      activeClass="has-text-danger"
      :highlightFirstItem="true"
      :scrollOffset="0"
      :offset="0"
      :modifyUrl="false"
    >
      <div class="navbar-brand">
        <a
          role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarBasicExample"
          :class="{ 'is-active': showNav }"
          @click="showNav = !showNav"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div
        id="navbarBasicExample"
        class="navbar-menu pl-5"
        :class="{ 'is-active': showNav }"
      >
        <div class="navbar-start">
          <span class="navbar-item pl-5">
            <a href="#home" class="scrollactive-item has-text-white">
              HOME
            </a>
          </span>
          <span class="navbar-item pl-5">
            <a href="#about" class="scrollactive-item has-text-white">
              ABOUT
            </a>
          </span>
          <span class="navbar-item pl-5">
            <a href="#projects" class="scrollactive-item has-text-white">
              PROJECTS
            </a>
          </span>
          <span class="navbar-item pl-5">
            <a href="#contact" class="scrollactive-item has-text-white">
              CONTACT
            </a>
          </span>
        </div>
        <div class="navbar-end">
          <span class="navbar-item">
            <a download class="button is-link" href="static/resume.pdf">
              <span class="icon is-small">
                <i class="fas fa-download"></i>
              </span>
              <span>RESUME</span>
            </a>
          </span>
        </div>
      </div>
    </scrollactive>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      showNav: false,
      showNavOnScroll: false,
      isModalActive: false,
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll(event) {
      if (document.getElementById('bio').classList.contains('animated')) {
        let navbar = document.getElementById('navbar')
        navbar.classList.remove('is-fixed')
        navbar.classList.add('is-fixed-top', 'animated', 'slide-in-up')
      }
    },
  },
}
</script>

<style lang="sass">
.navbar
  background-color: darken(#112931, 4) !important
  z-index: 9999 !important
.navbar-item
  font-family: 'Raleway', sans-serif !important
  font-weight: 500
.navbar-menu
  background-color: darken(#112931, 4)
  z-index: 9999 !important
.navbar-menu.is-active
  background-color: #112931 !important
.navbar-burger.burger
  z-index: 9999 !important
  color: white
</style>
